import CheckList from "@editorjs/checklist";
import Code from "@editorjs/code";
import Delimiter from "@editorjs/delimiter";
import Embed from "@editorjs/embed";
import Image from "@editorjs/image";
import InlineCode from "@editorjs/inline-code";
import LinkTool from "@editorjs/link";
import List from "@editorjs/list";
import Marker from "@editorjs/marker";
import Quote from "@editorjs/quote";
import Raw from "@editorjs/raw";
import Table from "@editorjs/table";
import Paragraph from "@editorjs/paragraph";
import Header from "@editorjs/header";


export const EDITOR_JS_TOOLS = {
  embed: {
    class: Embed,
    inlineToolBar: true,
    toolbox: {
      icon: '<p>Insert Embed</p>'
    }
  },
  header:  {
    class: Header,
    inlineToolBar: true,
    toolbox: {
      icon: '<p>Insert Header</p>',
    }
  },
  paragraph: {
    class: Paragraph,
    inlineToolBar: ["task"],
    toolbox: {
      icon: '<p>Insert Paragraph</p>',
    }
  },
  table: {
    class: Table,
    toolbox: {
      icon: '<p>Insert Table</p>',
    }
  },
  list: {
    class: List,
    inlineToolBar: true,
    toolbox: {
      icon: '<p>Insert List</p>',
    }
  },
  code: {
    class: Code,
    toolbox: {
      icon: '<p>Insert code snippet</p>'
    }
  },
  linkTool: {
    class: LinkTool,
    toolbox: {
      icon: '<p>Insert Link</p>'
    }
  },
  image: {
    class: Image,
    toolbox: {
      icon: '<p>Insert Image</p>'
    }
  },
  raw: {
    class: Raw,
    toolbox: {
      icon: '<p>Insert HTML code</p>'
    }
  },
  quote: {
    class: Quote,
    toolbox: {
      icon: "<p>Insert Quote</p>"
    }
  },
  marker: { 
    class: Marker,
    toolbox: {
      icon: '<p>Insert Marker</p>'
    }
  },
  checklist: {
    class: CheckList,
    inlineToolBar: true,
    toolbox:  {
      icon: '<p>Insert Checklist</p>',
    }
  },
  delimiter: {
    class: Delimiter,
    toolbox: {
      icon: '<p>Insert Delimiter</p>'
    }
  },
  inlineCode: {
    class: InlineCode,
    toolbox: {
      icon: '<p>Insert Inline code</p>'
    }
  },
};
